import { render, staticRenderFns } from "./ListBills.vue?vue&type=template&id=a54624a2&scoped=true"
import script from "./ListBills.vue?vue&type=script&lang=js"
export * from "./ListBills.vue?vue&type=script&lang=js"
import style0 from "./ListBills.vue?vue&type=style&index=0&id=a54624a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54624a2",
  null
  
)

export default component.exports